import { events } from '../EventBus';
import { EnemyType } from '../types';
import {
  SCORE_BLOCK, SCORE_POWERUP, SCORE_ENEMY_BASIC, SCORE_ENEMY_FAST,
  SCORE_ENEMY_SMART, SCORE_ENEMY_HUNTER, SCORE_ENEMY_BOMBER, SCORE_ENEMY_BOSS,
  SCORE_TIME_BONUS,
} from '../constants';

export class ScoreSystem {
  private _score = 0;
  private _level = 1;
  private _combo = 0;
  private _comboTimer = 0;
  private readonly COMBO_WINDOW = 2000;

  constructor() {
    this.bindEvents();
  }

  private bindEvents(): void {
    events.on('block:destroyed', () => this.add(SCORE_BLOCK));
    events.on('powerup:collected', () => this.add(SCORE_POWERUP));
    events.on('enemy:killed', ({ type }) => {
      this._combo++;
      this._comboTimer = this.COMBO_WINDOW;
      const base = this.enemyScore(type);
      const multiplier = Math.min(this._combo, 8);
      this.add(base * multiplier);
    });
  }

  private enemyScore(type: EnemyType): number {
    switch (type) {
      case EnemyType.BASIC: return SCORE_ENEMY_BASIC;
      case EnemyType.FAST: return SCORE_ENEMY_FAST;
      case EnemyType.SMART: return SCORE_ENEMY_SMART;
      case EnemyType.HUNTER: return SCORE_ENEMY_HUNTER;
      case EnemyType.BOMBER: return SCORE_ENEMY_BOMBER;
      case EnemyType.BOSS: return SCORE_ENEMY_BOSS;
    }
  }

  add(amount: number): void {
    this._score += amount;
    events.emit('score:changed', { score: this._score, delta: amount });
  }

  addTimeBonus(secondsLeft: number): void {
    const bonus = secondsLeft * SCORE_TIME_BONUS;
    this.add(bonus);
  }

  update(delta: number): void {
    if (this._comboTimer > 0) {
      this._comboTimer -= delta;
      if (this._comboTimer <= 0) this._combo = 0;
    }
  }

  reset(level: number): void {
    this._level = level;
    this._combo = 0;
    this._comboTimer = 0;
  }

  get score(): number { return this._score; }
  get level(): number { return this._level; }
  get combo(): number { return this._combo; }

  resetScore(): void {
    this._score = 0;
  }

  destroy(): void {
    events.removeAll();
  }
}
